import { rgba } from 'polished';
import styled from 'styled-components';
import { rect, RectProps } from '../../../components/styles';

type Props = RectProps & {
  error?: boolean;
};

export const Radio = styled.input.attrs({ type: 'radio' })<Props>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  appearance: none;
  cursor: pointer;
  flex-shrink: 0;

  &::before {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.backgroundColors.white};
    border: 1px solid ${({ theme }) => theme.borderColors.default};
    border-radius: 50%;
    content: '';
    flex-shrink: 0;
  }

  &::after {
    position: absolute;
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    transition: background-color 0.1s;
    content: '';
    flex-shrink: 0;
  }

  &:checked::before {
    border-color: ${({ theme }) => theme.borderColors.primary};
    box-shadow: 0 1px 8px
      ${({ theme }) => rgba(theme.backgroundColors.primary, 0.3)};
  }

  &:checked::after {
    background: ${({ theme }) => theme.backgroundColors.primary};
  }

  ${({ theme, error = false }) => {
    if (!error) {
      return {
        background: theme.backgroundColors.white,
        color: theme.fontColors.default,
        '&:hover, &:focus': {
          borderColor: theme.borderColors.primary,
        },
      };
    } else {
      return {
        background: theme.backgroundColors.error,
        borderColor: theme.borderColors.secondary,
        color: theme.fontColors.pink,
      };
    }
  }}
`;
